export const TRANSACTION_TYPES = {
    BUY: 'Purchase',
    SELL: 'Sale',
    SWAP: 'Swap',
    DIVIDEND: 'Dividend',
    GAS: 'Gas',
}